
export enum Subject {
  MATH = 'Math',
  SCIENCE = 'Science',
  LANGUAGE_ARTS = 'Language Arts',
  SOCIAL_STUDIES = 'Social Studies',
}

export enum QuestionType {
  MULTIPLE_CHOICE = 'multiple_choice',
  TRUE_FALSE = 'true_false',
  FILL_IN_THE_BLANK = 'fill_in_the_blank'
}

export enum Difficulty {
  EASY = 'Easy',
  MEDIUM = 'Medium',
  HARD = 'Hard'
}

export enum UserStatus {
  ONBOARDING = 'Onboarding',
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum UserRole {
  STUDENT = 'student',
  ADMIN = 'admin',
  PARENT = 'parent',
  TEACHER = 'teacher'
}

export interface QuizResponse {
  passage?: string;
  diagram?: string; // SVG markup for visual topics (geometry, graphs, etc.)
  questions: Question[];
}

export interface Question {
  id: string;
  text: string;
  type: QuestionType;
  options: string[]; // For multiple choice
  correctAnswer: string;
  explanation: string;
}

export interface Flashcard {
  id: string;
  front: string;
  back: string;
}

export interface QuizConfig {
  grade: string;
  state: string; // e.g., 'TX', 'CA', 'NY'
  subject: Subject;
  topic: string;
  difficulty: Difficulty;
  timed: boolean;
}

export interface Badge {
  id: string;
  name: string;
  icon: string;
  description: string;
  unlocked: boolean;
}

// Extended User Profile for Auth
export interface User {
  id: string;
  email: string;
  password?: string; // stored in localstorage for simulation
  role: UserRole;
  status: UserStatus;

  // Profile Data
  name: string;
  grade: number;
  state: string;
  points: number;
  weeklyGoal: number; // New: Goal setting
  badges: Badge[];
  quizCount?: number;
  recentScores: {
    quizId: string;
    score: number;
    date: string;
    subject?: Subject;
    topic?: string;
    difficulty?: Difficulty;
    totalQuestions?: number;
    correctCount?: number;
  }[];
}

// Backwards compatibility alias if needed, but we should use User primarily now
export type UserProfile = User;
